// extracted by mini-css-extract-plugin
module.exports =  {"breadcrumb":"seom__uTODnNW0XEVrDEPzr4YD"};